var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 111,
    viewBox: "0 0 186 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.053 5.9362C129.026 3.19381 131.758 1.25 134.642 1.25H179.691C183.11 1.25 185.558 3.95412 185.161 7.29023L173.527 104.959C173.13 108.295 170.037 111 166.618 111H23.6613C20.243 111 17.7944 108.295 18.1917 104.959L27.9642 22.9207C28.3615 19.5845 31.4545 16.8804 34.8728 16.8804H112.663C119.397 16.8804 125.78 12.3417 128.053 5.9362Z",
    fill: "#FFAA0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7842 106.504H170.145L178.656 6.00391H29.295L20.7842 106.504Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7842 106.504H170.145L176.303 6.00391H29.295L20.7842 106.504Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7842 106.502H170.145L175.279 2.8125H25.9183L20.7842 106.502Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7842 106.502H170.145L172.177 2.8125H25.9183L20.7842 106.502Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7842 106.503H170.145L171.035 0H21.6739L20.7842 106.503Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7843 106.503H170.145L167.08 2.01562H18.6807L20.7843 106.503Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7845 106.502H170.145L165.712 2.8125H16.3516L20.7845 106.502Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.786 106.505H170.147L163.087 4.37891H13.7266L20.786 106.505Z",
    fill: "#E0E0E0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7846 106.505H170.145L161.96 5.25391H12.5996L20.7846 106.505Z",
    fill: "#EBEBEB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5812 12.2781C95.6791 9.46821 97.7918 7.47656 100.675 7.47656H145.724C149.142 7.47656 152.454 10.2477 153.122 13.6654L170.919 104.81C171.586 108.228 169.357 110.999 165.938 110.999H22.9814C19.5631 110.999 16.2512 108.228 15.5837 104.81L0.913978 29.6807C0.246531 26.2625 2.47623 23.4919 5.89451 23.4919H83.6842C90.4183 23.4919 95.3527 18.8412 95.5812 12.2781Z",
    fill: "#FFAA0D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.5812 12.2781C95.6791 9.46821 97.7918 7.47656 100.675 7.47656H145.724C149.142 7.47656 152.454 10.2477 153.122 13.6654L170.919 104.81C171.586 108.228 169.357 110.999 165.938 110.999H22.9814C19.5631 110.999 16.2512 108.228 15.5837 104.81L0.913978 29.6807C0.246531 26.2625 2.47623 23.4919 5.89451 23.4919H83.6842C90.4183 23.4919 95.3527 18.8412 95.5812 12.2781Z",
    fill: "#FFAA0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/FolderIcon.18a99ff091e40995ed3b591c4acba930.svg";
export { ForwardRef as ReactComponent };